import styled from "styled-components";

export const HomeBannerCont = styled.section<{ isShobiddak?: boolean }>`
  &.HomeBannerConDesktop {
    height: 260px;
  }

  #homeBannerMobileOne {
    min-height: 115px;
  }

  & div {
    background: ${({ theme: { isRTL }, isShobiddak }) =>
      isRTL
        ? `linear-gradient(90deg,  ${
            isShobiddak ? "#3171b2" : "#3475b4"
          } 50%, ${isShobiddak ? "#9fc751" : "#a5cb55"} 50%);`
        : `linear-gradient(90deg,  ${
            isShobiddak ? "#9fc751" : "#a5cb55"
          } 50%, ${isShobiddak ? "#3171b2" : "#3475b4"} 50%);`};
    ${({ theme: { isDesktop } }) =>
      isDesktop
        ? `
          right:0;
          left:0;
          height: 260px;
          @media only screen and (max-width: 1200px) {
            width: 1200px;
          }
          @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
          width:100%
          }
        `
        : ` height: 119px;
        `};
  }
`;
